import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../config";
import { prepareHeaders } from "./utils";
import type { SectionDraftGetResponse } from "../../../../src/api/src/documents/drafts/sections";

// eslint-disable-next-line
const sectionDraftTagType = "sectionDrafts" as const;

export const sectionDraftsApi = createApi({
  reducerPath: "sectionDraftsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.api,
    prepareHeaders,
  }),
  tagTypes: [sectionDraftTagType],
  endpoints: (builder) => ({
    getSectionDrafts: builder.query<SectionDraftGetResponse, { docId: string }>(
      {
        query: ({ docId }) => `documents/${docId}/drafts/sections`,
        providesTags: (result) => [
          ...(result?.map((d) => ({
            type: sectionDraftTagType,
            id: d.id,
          })) ?? []),
          { type: sectionDraftTagType, id: "LIST" },
        ],
      },
    ),
  }),
});

export const { useGetSectionDraftsQuery } = sectionDraftsApi;
